/**
 * Store-routing reserved slugs. The store proxy (apps/store-next/src/proxy.ts)
 * dispatches by pathname.startsWith(...), so prefixes reserve every slug that
 * starts with them — `portal-2` is as unreachable as `portal`.
 */
export const RESERVED_SLUG_PREFIXES = [
  'portal',
  'embed',
  'overlay',
  'unsubscribe', // proxy rewrites (prefix)
  'api',
  'public',
  'store-static',
  'favicon', // proxy matcher bypasses (prefix)
  '_next', // Next.js internals — typeable since the slug charset allows underscores
];

/**
 * Exact-only reservations: well-known root files. The proxy catch-all serves
 * these as regular pages, letting a slug shadow crawler/PWA/domain-verification
 * URLs — and any future real route for them would silently break the page.
 * Exact matches so e.g. `robots-guide` stays legal.
 */
export const RESERVED_SLUGS = ['robots.txt', 'sitemap.xml', 'manifest.json', '.well-known'];

// Strips leading slashes and lowercases first: seller-API schemas validate the
// raw slug before the service-side normalizePageSlug runs.
export function isReservedSlug(slug: string): boolean {
  const normalized = slug.replace(/^\/+/, '').toLowerCase();

  return (
    RESERVED_SLUG_PREFIXES.some(prefix => normalized.startsWith(prefix)) ||
    RESERVED_SLUGS.includes(normalized)
  );
}
